export default __webpack_public_path__ + "media/lang_icon_dark.16b7acd7.svg";